import { SecuredKoppClient } from '../../../../Core/Api/Kopp/SecuredKoppClient';
import { SlimUser, LoginCommandRequest, GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest } from '../../../../Core/Api/Kopp/Api';

export class TrackedBolFileHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetBolFileTypes() {
    const client = new SecuredKoppClient();
    const request = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest();
    request.amountPerPage = 200;
    client.showLoading = true;
    client.handleGeneralError = true;
    return client.getFilteredTrackedBolFileTypeForLoggedInUser(request);
  }
}
